import React from 'react';

type IconProps = React.HTMLAttributes<SVGElement>;

export const Icons = {
	Twitter: (props: IconProps) => (
		<svg
			{...props}
			height="23"
			viewBox="0 0 1200 1227"
			width="23"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
		</svg>
	),
	Google: (props: IconProps) => (
		<svg role="img" viewBox="0 0 24 24" {...props}>
			<path
				d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
				fill="currentColor"
			/>
		</svg>
	),
	Apple: (props: IconProps) => (
		<svg role="img" viewBox="0 0 24 24" {...props}>
			<path
				d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
				fill="currentColor"
			/>
		</svg>
	),
	Paypal: (props: IconProps) => (
		<svg role="img" viewBox="0 0 24 24" {...props}>
			<path
				d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.93 4.778-4.005 7.201-9.138 7.201h-2.19a.563.563 0 0 0-.556.479l-1.187 7.527h-.506l-.24 1.516a.56.56 0 0 0 .554.647h3.882c.46 0 .85-.334.922-.788.06-.26.76-4.852.816-5.09a.932.932 0 0 1 .923-.788h.58c3.76 0 6.705-1.528 7.565-5.946.36-1.847.174-3.388-.777-4.471z"
				fill="currentColor"
			/>
		</svg>
	),
	Spinner: (props: IconProps) => (
		<svg
			fill="none"
			height="24"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			viewBox="0 0 24 24"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M21 12a9 9 0 1 1-6.219-8.56" />
		</svg>
	),
	LockIcon: (props: IconProps) => (
		<svg
			{...props}
			fill="none"
			height="20"
			viewBox="0 0 17 20"
			width="17"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.6201 11.5V14.5M1 7.92736V18.3184H16.2402V7.92736H1ZM3.77094 7.92736C3.77094 3.77094 3.77094 1 8.6201 1C13.4692 1 13.4692 3.77094 13.4692 7.92736H3.77094Z"
				stroke="#00E889"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
			/>
			<path
				d="M8.62047 12.8547C9.00306 12.8547 9.31321 12.5446 9.31321 12.162C9.31321 11.7794 9.00306 11.4692 8.62047 11.4692C8.23788 11.4692 7.92773 11.7794 7.92773 12.162C7.92773 12.5446 8.23788 12.8547 8.62047 12.8547Z"
				stroke="#00E889"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
			/>
		</svg>
	),
	CircleCheckIcon: (props: IconProps) => (
		<svg
			{...props}
			fill="none"
			height="22"
			viewBox="0 0 22 22"
			width="22"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="11" cy="11" fill="#00E889" r="11" />
			<path
				d="M15.538 6L17.1748 7.67813L9.18828 15.473L5 11.4736L6.61906 9.77859L9.17047 12.2152L15.538 6Z"
				fill="#022E4A"
			/>
		</svg>
	),
};
